<template>
  <b-card header="Totales" class="presupuesto-totales">
    <b-btn class="btn-collapse-card" 
        variant="primary" 
        size="sm"
        @click.prevent="showTotales= !showTotales">
      <i :class="showTotales ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="totales" class="mt-2" v-model="showTotales">
      <form>
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group
              v-if="montoDescuentoOrdenes != 0"
              label="Cotización"
              label-for="montoCotizacionBruta"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoCotizacionBruta"
                :value="montoCotizacionBruta | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="montoDescuentoOrdenes != 0"
              label="Dto Ordenes"
              label-for="montoDescuentoOrdenes"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoDescuentoOrdenes"
                :value="montoDescuentoOrdenes | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cotización"
              label-for="montoCotizacion"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoCotizacion"
                :value="montoCotizacion | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="!isAdicional & accesoDescuentoRebate"
              label="Dto Rebate"
              label-for="importeDescuentoRebate"
              :labelCols="3"
              horizontal>
              <b-form-input 
                id="importeDescuentoRebate"
                v-model.trim="$v.importeDescuentoRebate.$model" 
                :state="importeDescuentoRebateValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeDescuentoRebateFeedback">
                {{ importeDescuentoRebateInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="isAdicional || !accesoDescuentoRebate"
              label="Dto Rebate"
              label-for="importeDescuentoRebate"
              :labelCols="3"
              horizontal>
              <b-form-input 
                id="importeDescuentoRebate"
                :value="importeDescuentoRebate | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Subtotal"
              label-for="montoSubtotalRebate"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoSubtotalRebate"
                :value="montoSubtotalRebate | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Financiacion"
              label-for="montoFinanciacion"
              :label-cols="3"
              :description="feeSobreFinanciacion? 'Fee aplica sobre financiación' : ''"
              horizontal>
              <b-form-input 
                id="montoFee"
                :value="montoFinanciacion | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fee"
              label-for="montoFee"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoFee"
                :value="montoFee | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Subtotal"
              label-for="montoSubtotal"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoSubtotal"
                :value="montoSubtotal | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="!isAdicional & accesoDescuento"
              label="Descuento"
              label-for="importeDescuento"
              :labelCols="3"
              horizontal>
              <b-form-input 
                id="importeDescuento"
                v-model.trim="$v.importeDescuento.$model" 
                :state="importeDescuentoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeDescuentoFeedback">
                {{ importeDescuentoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="isAdicional || !accesoDescuento"
              label="Descuento"
              label-for="importeDescuento"
              :labelCols="3"
              horizontal>
              <b-form-input 
                id="importeDescuento"
                :value="importeDescuento | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group
              label="Total"
              label-for="montoTotal"
              :label-cols="3"
              v-if="monedaId != 101"
              horizontal>
              <b-form-input 
                id="montoTotal"
                :value="montoTotal | moneda(monedaSimbolo)" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Neto"
              label-for="montoNeto"
              :label-cols="3"
              v-if="condicionFiscalId != 3"
              horizontal>
              <b-form-input 
                id="montoNeto"
                :value="montoNeto | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Impuestos"
              label-for="montoImpuestos"
              :label-cols="3"
              v-if="condicionFiscalId != 3"
              horizontal>
              <b-form-input 
                id="montoImpuestos"
                :value="montoImpuestos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Total"
              label-for="montoTotalPesos"
              :label-cols="3"
              horizontal>
              <b-form-input 
                id="montoTotalPesos"
                :value="montoTotalPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pje Rentabilidad"
              label-for="pjeRentabilidad"
              :label-cols="3"
              horizontal
              description="Rentabilidad total sobre la cotización y el costo interno">
              <b-form-input 
                id="pjeRentabilidad"
                :value="pjeRentabilidad | porcentaje" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pje Rent. s/Reemb."
              label-for="pjeRentabilidadSinReembolsos"
              :label-cols="3"
              horizontal
              description="Rentabilidad sobre la cotización y el costo interno excl. reembolsos">
              <b-form-input 
                id="pjeRentabilidadSinReembolsos"
                :value="pjeRentabilidadSinReembolsos | porcentaje" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-collapse>
  </b-card>
</template>

<script>
import { decimal, minValue } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'ABMTotales',
  props: {
    confirmado: {
      type: Boolean,
      default: false
    },
    isAdicional: {
      type: Boolean,
      default: false
    },
    accesoDescuento: {
      type: Boolean,
      default: false
    },
    accesoDescuentoRebate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      noValidar: true,
      importeDescuentoRebateValido: null,
      importeDescuentoRebateInvalidoMsj: '',
      importeDescuentoValido: null,
      importeDescuentoInvalidoMsj: '',

      showTotales: true
    }
  },
  computed: {
    ...mapFields([
      'condicionFiscalId',
      'monedaId',
      'feeSobreFinanciacion',

      'montoCosto',
      'montoCotizacionBruta',
      'montoDescuentoOrdenes',
      'montoCotizacion',
      'importeDescuentoRebate',
      'montoSubtotalRebate',
      'montoFinanciacion',
      'montoFee',
      'montoFeePremios',
      'montoSubtotal',
      'importeDescuento',

      'montoTotal',
      'montoNeto',
      'montoImpuestos',
      'montoTotalPesos',
      'pjeRentabilidad',
      'pjeRentabilidadSinReembolsos',

      'montoCertificado'
    ]),
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
    isCertificado() {
      if (this.montoCertificado) {
        if (this.montoCertificado != 0) {
          return true;
        }
      }
      return false;
    }
  },  
  created() {
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importeDescuentoRebate' || validarTodos) {
        if (this.$v.importeDescuentoRebate.$error) {
          this.importeDescuentoRebateValido = false;
          if (!this.$v.importeDescuentoRebate.decimal) {
            this.importeDescuentoRebateInvalidoMsj = 'El importe de descuento debe ser un valor numérico';
          } else {
            if (!this.$v.importeDescuentoRebate.minValue) {
              this.importeDescuentoRebateInvalidoMsj = 'El importe de descuento ingresado no es válida';
            }      
          }     
        } else {
          this.importeDescuentoRebateValido = null;
          this.importeDescuentoRebateInvalidoMsj = '';
        }
      }

      if (campo == 'importeDescuento' || validarTodos) {
        if (this.$v.importeDescuento.$error) {
          this.importeDescuentoValido = false;
          if (!this.$v.importeDescuento.decimal) {
            this.importeDescuentoInvalidoMsj = 'El importe de descuento debe ser un valor numérico';
          } else {
            if (!this.$v.importeDescuento.minValue) {
              this.importeDescuentoInvalidoMsj = 'El importe de descuento ingresado no es válida';
            }      
          }     
        } else {
          this.importeDescuentoValido = null;
          this.importeDescuentoInvalidoMsj = '';
        }
      }
    }
  },
  validations: {
    importeDescuentoRebate: {
      decimal,
      minValue: minValue(0)
    },
    importeDescuento: {
      decimal,
      minValue: minValue(0)
    },
  },
  watch: {
    'importeDescuentoRebate' : function(newVal, oldVal) {
      if ( newVal != oldVal) {
        this.$store.dispatch('presupuestointerno/calcularTotales')
          .catch(error => this.showErrorMsj(error))
      }
    },
    'importeDescuento' : function(newVal, oldVal) {
      if ( newVal != oldVal) {
        this.$store.dispatch('presupuestointerno/calcularTotales')
          .catch(error => this.showErrorMsj(error))
      }
    },
  }
}
</script>

<style>
</style>
